import { Container, Grid } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { getClientNovelties, getNovelties, showNoveltyBySlug } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import useUserDisplaytime from '../../../../shared/hooks/useUserDisplaytime'
import { MoreInfoDetail } from '../../../library/models/resource'
import NewsContent from '../../ui/components/NewsContent'
import NewsDetailsPanel from '../components/NewsDetailsPanel'
import NoveltiesNotifications from '../components/NewsNotifications'
import NewsModal from '../components/modal/NewsModal'

function NewDetails() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()
  const [favoriteState, setFavoriteState] = useState<boolean>(false)
  const { news, newsSelected, showForm } = useSelector((state: IRootState) => state.novelty)
  const { globalFamilyId, globalBrandId, globalCountryId, globalCountriesId, globalLanguageId } = useSelector(
    (state: IRootState) => state.global
  )
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const isAdmin = location.pathname.includes('admin')
  useUserDisplaytime({ foreign: newsSelected })

  const infoDetail: MoreInfoDetail = {
    item: [
      {
        id: 0,
        type: 'tag',
        title: 'Tags',
        color: 'light',
        info: `${newsSelected?.tags
          ?.map((tag: any) => {
            return tag.name.toUpperCase()
          })
          .join(', ')}`
      },
      {
        id: 1,
        type: 'date',
        title: `${t('admin.people.created-date')}`,
        color: 'grey6',
        info: `${dayjs(newsSelected?.created_at).format('LL')}`
      }
    ]
  }

  useEffect(() => {
    if (news.length === 0) {
      dispatch(
        getClientNovelties({
          brand_id: globalBrandId,
          country_id: globalCountryId,
          language_id: globalLanguageId,
          type: 'news',
          requesttype: 2
        })
      )
    }
  }, [])

  useEffect(() => {
    dispatch(showNoveltyBySlug({ slug, type: 'newsSelected' }))
  }, [slug])

  useEffect(() => {
    if (newsSelected !== null) {
      setFavoriteState(Boolean(newsSelected.favoriteId))
    }
  }, [newsSelected])

  useEffect(() => {
    if (news.length === 0 && authUser !== null) {
      if (isAdmin) {
        dispatch(
          getNovelties({
            family_id: globalFamilyId,
            brand_id: globalBrandId,
            language_id: globalLanguageId,
            countries: globalCountriesId,
            requesttype: 2,
            type: 'news'
          })
        )
      } else {
        dispatch(
          getClientNovelties({
            brand_id: globalBrandId,
            country_id: globalCountryId,
            language_id: globalLanguageId,
            type: 'news',
            requesttype: 2
          })
        )
      }
    }
  }, [globalBrandId, globalCountryId, globalLanguageId])

  return (
    <>
      {newsSelected != null && (
        <Container maxWidth="lg">
          {showForm && <NewsModal />}
          <ButtonBack />

          <Grid container spacing={isMobile ? 1 : 5} direction={isMobile ? 'column-reverse' : 'row-reverse'}>
            <NewsDetailsPanel newsSelected={newsSelected} news={news} isAdmin={isAdmin} isMobile={isMobile} infoDetail={infoDetail} />

            <NewsContent
              newsSelected={newsSelected}
              isAdmin={isAdmin}
              isMobile={isMobile}
              authUser={authUser}
              favoriteState={favoriteState}
              setFavoriteState={setFavoriteState}
              infoDetail={infoDetail}
            />
          </Grid>
        </Container>
      )}

      <NoveltiesNotifications />
    </>
  )
}

export default NewDetails
